<sirius-container>
    <article class="feature">
        @switch (resolvedMediaItem().type) {
            @case ('image') {
                <figure class="feature-media">
                    <sirius-image-item
                        [image]="resolvedMediaItem() | cast"
                        [imageData]="imageData()"
                        [objectFit]="'cover'"
                        [alt]="imageAlt()"
                        data-cy="feature-image"
                    ></sirius-image-item>
                </figure>
            }
            @case ('video') {
                <div class="feature-media">
                    <sirius-video-item
                        [video]="resolvedMediaItem() | cast"
                        data-cy="feature-video"
                    ></sirius-video-item>
                </div>
            }
        }

        <div class="feature-content">
            <sirius-heading
                [text]="resolvedTitle()"
                textStyleCategory="title"
                [textStyleSize]="headingTextStyleSize()"
                [h]="2"
                data-cy="feature-title"
            ></sirius-heading>

            <div class="feature-body">
                <sirius-text-html [html]="resolvedTextHtml()" textStyleSize="m"></sirius-text-html>

                @if (resolvedButtons().length) {
                    <footer class="feature-actions">
                        @for (action of resolvedButtons(); track $index) {
                            <a
                                siriusButton
                                [siriusLink]="action.button.link"
                                [iconName]="action.button.iconName"
                                [buttonText]="action.button.link.title"
                                [buttonType]="action.buttonType"
                                data-cy="feature-button"
                            >
                            </a>
                        }
                    </footer>
                }
            </div>
        </div>
    </article>
</sirius-container>
